module.exports = __webpack_public_path__ + "files/b363014d10ae29165c27caaf2c7149a6.png";